(() => {
  const codeLabel = /(?:كود|رمز)\s*(?:المنتج|الصنف)|product\s*(?:code|id)|(?:^|\s)sku\s*[:#-]?/i;
  const codeToken = /(?:^|\s)(?:PRD|SKU|CTN)[-_ ]?[A-Z0-9][A-Z0-9_-]{2,}(?=\s|$)/gi;
  const descriptionSelector = [
    '[data-product-description]',
    '.product-details .rte',
    '.product-information .rte',
    '.made-product-description .rte',
    '.product-description'
  ].join(',');
  const priceSelector = [
    '.made-price__current',
    '.made-price__compare',
    '.price',
    '.money',
    '[data-testid="price"]',
    '.cart-item__price',
    '.totals__total-value'
  ].join(',');

  const removeCodeLines = (description) => {
    if (description.dataset.miCodesHidden === 'true') return;
    description.dataset.miCodesHidden = 'true';

    description.querySelectorAll('p, li, tr').forEach((node) => {
      if (codeLabel.test(node.textContent.trim())) node.remove();
    });

    description.querySelectorAll('div').forEach((node) => {
      const hasBlockChildren = node.querySelector('p, li, tr, div');
      const text = node.textContent.trim();
      if (!hasBlockChildren && text.length <= 220 && codeLabel.test(text)) node.remove();
    });

    description.querySelectorAll('br').forEach((br) => {
      const lineNodes = [];
      let node = br.previousSibling;
      while (node && node.nodeName !== 'BR') {
        lineNodes.unshift(node);
        node = node.previousSibling;
      }
      const lineText = lineNodes.map((item) => item.textContent || '').join('').trim();
      if (codeLabel.test(lineText)) {
        lineNodes.forEach((item) => item.remove());
        br.remove();
      }
    });

    [...description.childNodes]
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .forEach((node) => {
        const cleanLines = node.textContent.split(/\r?\n/).filter((line) => !codeLabel.test(line));
        node.textContent = cleanLines.join('\n');
      });
  };

  const formatPriceNode = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      if (node.parentElement?.closest('.mi-money-fraction')) return;
      const text = node.textContent;
      const match = text.match(/([.,])(\d{2})(?=\s|$|[^\d])/);
      if (!match) return;

      const index = match.index;
      const fragment = document.createDocumentFragment();
      fragment.append(text.slice(0, index));
      const fraction = document.createElement('span');
      fraction.className = 'mi-money-fraction';
      fraction.textContent = match[0];
      fragment.append(fraction, text.slice(index + match[0].length));
      node.replaceWith(fragment);
    });
  };

  const cleanCustomerCard = (card) => {
    card.querySelectorAll('.made-card__excerpt').forEach((excerpt) => {
      if (codeLabel.test(excerpt.textContent) || codeToken.test(excerpt.textContent)) excerpt.remove();
      codeToken.lastIndex = 0;
    });
    card.querySelectorAll('.made-card__title, [class*="product-title"], .product-card__title').forEach((title) => {
      const cleaned = title.textContent.replace(/\*\*/g, '').replace(codeToken, ' ').replace(/[—–-]\s*$/g, '').replace(/\s{2,}/g, ' ').trim();
      codeToken.lastIndex = 0;
      if (cleaned && cleaned !== title.textContent.trim()) title.textContent = cleaned;
    });
  };

  const cardSelector = '.made-card, product-card, .product-card';
  const relevantSelector = `${descriptionSelector},${cardSelector},${priceSelector}`;
  const pendingRoots = new Set();
  let scheduled = false;

  const matchingElements = (root, selector) => {
    if (!(root instanceof Element || root instanceof Document)) return [];
    return [
      ...(root instanceof Element && root.matches(selector) ? [root] : []),
      ...root.querySelectorAll(selector)
    ];
  };

  const processRoot = (root) => {
    if (document.body.classList.contains('template-product')) {
      matchingElements(root, descriptionSelector).forEach(removeCodeLines);
      if (root instanceof Element) {
        const description = root.closest(descriptionSelector);
        if (description) removeCodeLines(description);
      }
    }

    matchingElements(root, cardSelector).forEach(cleanCustomerCard);
    if (root instanceof Element) {
      const card = root.closest(cardSelector);
      if (card) cleanCustomerCard(card);
    }

    matchingElements(root, priceSelector).forEach(formatPriceNode);
    if (root instanceof Element) {
      const price = root.closest(priceSelector);
      if (price) formatPriceNode(price);
    }
  };

  const flush = () => {
    scheduled = false;
    const roots = [...pendingRoots];
    pendingRoots.clear();
    roots.forEach(processRoot);
  };

  const schedule = (root = document) => {
    if (root instanceof Element) {
      const relevant = root.matches(relevantSelector) || root.closest(relevantSelector) || root.querySelector(relevantSelector);
      if (!relevant) return;

      for (const pendingRoot of pendingRoots) {
        if (pendingRoot instanceof Document || pendingRoot.contains(root)) return;
        if (root.contains(pendingRoot)) pendingRoots.delete(pendingRoot);
      }
    }
    pendingRoots.add(root);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(flush);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        const root = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
        if (root) schedule(root);
      });
    });
  });

  const init = () => {
    schedule(document);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => schedule(event.target));
})();
